import styled, { css } from 'styled-components';

interface IPropsCard {
  typePlan?: 'Anual' | 'Mensal' | 'Free';
}

export const CardPlanContainer = styled.div<IPropsCard>`
  display: flex;
  flex-direction: column;
  position: relative;

  width: 100%;
  min-width: 21.25rem;
  max-width: 21.25rem;
  height: 100%;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;

  border-radius: 16px;
  background: ${(props) => props.theme.white};
  border: 3px solid;
  border-color: ${(props) => props.theme['orange-400']};

  .fancybox-inner {
    z-index: 1000000000000000 !important;
  }
`;

export const HeaderFlag = styled.div`
  border-radius: 8px;
  background-color: ${(props) => props.theme['orange-400']};

  font-size: 1rem;
  position: absolute;
  top: -12px;
  left: 54px;
  width: 225px;
  color: ${(props) => props.theme.white};
  text-align: center;
  font-weight: 600;
  padding: 2px;
`;

export const HeaderPromoImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 200px;
  background-color: ${(props) => props.theme['orange-400']};
  border: 3px solid ${(props) => props.theme['orange-400']};
  position: absolute;
  top: -15px;
  right: -15px;
  width: 70px;
  height: 70px;
  color: ${(props) => props.theme.white};
  text-align: center;
  font-weight: 700;
  .percent {
    font-size: 1.2rem;
    line-height: 1.1rem;
  }
  .off {
    font-size: 1rem;
    line-height: 1.3rem;
    letter-spacing: 1px;
  }
`;

export const HeaderBlackTip = styled.h4`
  background-color: ${(props) => props.theme['gray-600']};
  color: ${(props) => props.theme.white};
  border-radius: 8px;
  padding: 4px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 1rem;
  font-weight: 600;
`;

export const TypePlan = styled.div<IPropsCard>`
  display: flex;
  justify-content: flex-end;
  width: 7rem;
  height: 6rem;
  padding-top: 0.5rem;
  padding-right: 0.25rem;
  clip-path: polygon(100% 0, 0 0, 100% 69%);
  background: #303f4b;

  position: absolute;
  right: -1px;
  top: -1px;
  border-top-right-radius: 16px;
  span {
    font-size: 0.875rem;
    color: #fff;
    font-weight: 500;
    line-height: 21px;
  }
`;

export const PromotionIcon = styled.div`
  position: absolute;
  top: -1.5rem;
  right: -1.5rem;
  background: white;
  border-radius: 100%;
  overflow: hidden;
  padding: 1rem;
  border: 1px solid #0054b1;
`;

export const PromotionCard = styled.div`
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: #0176e1;
  padding: 0.75rem;

  span {
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
  }
`;

export const HeaderCard = styled.header`
  display: flex;
  flex-direction: column;
  gap: 0rem;
  align-items: center;
  margin: 1rem auto 0.75rem;
  width: 100%;

  h3 {
    font-family: 'Nunito', sans-serif;
    width: 100%;
    text-align: left;
    margin: 0;
    padding-left: 1.2rem;
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 54px;
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
    color: ${(props) => props.theme['gray-500']};
    margin-bottom: 1rem;
  }

  .textFree {
    font-weight: 400;
    font-size: 0.75rem;
    color: #252525;
    line-height: 18px;
    margin: 0;
  }
  span {
    color: ${(props) => props.theme['gray-n-400']};
    font-size: 1rem;
  }
`;

export const PriceContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.35rem;

  span {
    color: ${(props) => props.theme['gray-n-400']};
    font-size: 1.25rem;
  }

  div {
    color: ${(props) => props.theme['gray-500']};
    font-size: 1.25rem;
    font-weight: 700;
  }

  strong {
    color: ${(props) => props.theme['gray-500']};
    font-size: 2rem;
    font-weight: 700;
    line-height: normal;
  }
`;

export const PriceContentFrom = styled.div`
  span {
    color: ${(props) => props.theme['gray-n-400']};
    font-size: 1rem;
  }

  strong {
    color: ${(props) => props.theme['gray-400']};
    font-size: 1rem;
    font-weight: 700;
  }
`;

export const PriceContentOrEven = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-top: 2px solid;
  border-color: ${(props) => props.theme['orange-400']};
  background-color: blue;
  margin-top: 1rem;
  margin-bottom: 0.5rem;

  width: 90%;
  span {
    color: ${(props) => props.theme['gray-n-400']};
    font-size: 0.8rem;
    background-color: ${(props) => props.theme.white};
    width: 80px;
    position: absolute;
    text-align: center;
  }
`;

export const InformationText = styled.div`
  display: flex;
  justify-content: center;
  background: #ec6643;
  width: 100%;
  /* max-width: 21.25rem; */
  padding: 0.25rem;
  position: relative;

  h2 {
    font-weight: 600;
    font-size: 1.312rem;
    color: ${(props) => props.theme.white};
    margin: 0;
  }
`;

export const ListFunctionalitiesContent = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-left: 1rem;
  margin-top: 2.25rem;
  margin-bottom: auto;
`;

interface IPropsFunc {
  disabled: boolean;
  destaque?: boolean;
}

export const FunctionalityContent = styled.div<IPropsFunc>`
  display: grid;
  grid-template-columns: 1.125rem 1fr;
  margin-bottom: 0.75rem;
  gap: 0.5rem;
  width: 100%;
  align-items: center;

  svg {
    color: ${(props) =>
      props.disabled ? '#A4A6AC' : props.theme['orange-400']};
    width: 1.125rem;
    height: 1.125rem;
    font-size: 1rem;
  }

  strong {
    font-weight: 500;
    font-size: 0.875rem;
    color: ${(props) =>
      props.disabled ? props.theme['gray-100'] : props.theme['gray-300']};
  }
`;

interface IPropsButtonSelect {
  currentPlan?: boolean;
}

export const ButtonSelect = styled.button<IPropsButtonSelect>`
  padding: 0.5rem;
  /* topo | direita | inferior | esquerda */
  margin: 1rem;

  background-color: ${(props) => props.theme['orange-400']};
  color: ${(props) => props.theme['white']};
  border: ${(props) => `2px solid ${props.theme['orange-400']}`};
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  text-align: center;

  :hover {
    filter: brightness(0.9);
    transition: filter 0.3s;
  }

  a {
    color: ${(props) => props.theme['white']};
  }
`;

export const IconModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    background-color: ${(props) => props.theme['danger-300']};
    padding: 1.5rem;
    border-radius: 99999px;
  }
`;

export const ContentTextModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 2.5rem;

  p {
    margin: 0;
    color: #6c6c6c;
    font-size: 1rem;
    text-align: center;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;

  .outlineGray {
    border-color: ${(props) => props.theme['gray-600']};
    color: ${(props) => props.theme['gray-600']};
  }
`;
